import React from "react";
import { motion } from "framer-motion";

/**
 * Pickaxe Button
 */
const PiButton = (props) => {
  return (
    <div className="pi-button-box h-100 w-40">
      <motion.button whileTap={{ scale: 0.9 }} onClick={props.onClick}>
        {props.children && props.children}
      </motion.button>
    </div>
  );
};

export default PiButton;
